module.exports = __webpack_public_path__ + "static/img/rank.fefba279.jpg";